import { Component, HostBinding, input } from '@angular/core';

@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
})
export class LoadingSpinnerComponent {
  Size = input(42);
  @HostBinding('style.width') public width!: string;
  @HostBinding('style.height') public height!: string;

  ngOnInit(): void {
    if (this.Size()) {
      this.width = this.Size() + 'px';
      this.height = this.Size() + 'px';
    }
  }
}
